import { render, staticRenderFns } from "./LogisticsSideMenu.vue?vue&type=template&id=2430a7ad&"
import script from "./LogisticsSideMenu.vue?vue&type=script&lang=js&"
export * from "./LogisticsSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports